//modal

document.addEventListener('DOMContentLoaded', () => {
  const modalCloseBtns = document.querySelectorAll('.modal-close-btn') ?? []
  const modalOpenBtns = document.querySelectorAll('[data-modal]') ?? []

  modalOpenBtns.forEach((btn) => {
    const modal = document.querySelector(btn.dataset.modal)
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      modal.classList.add('modal-wrapper--open')
    })
  })

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      const modal = btn.closest('.modal-wrapper')
      if (modal) {
        modal.classList.remove('modal-wrapper--open')
      }
    })
  })
})
